module.exports = __webpack_public_path__ + "static/media/history_30.187078c1.jpg";